import React, {useCallback, useState} from 'react';
import './headerComponent.scss';
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {setSystemLocked} from "../../../../store/actions/account.action";
import {useNavigate} from "react-router-dom";
import {clearPreviousNav} from "../../../../store/actions/stateManagement.action";
import ButtonComponent from "../../core/button/ButtonComponent";
import LockIcon from "@mui/icons-material/Lock";
import SelectDropdownComponent from "../../core/select-dropdown/SelectDropdownComponent";
import {setSelectedLab} from "../../../../store/actions/selectedLab.action";
import NotificationModuleComponent from "../../notification-module/NotificationModuleComponent";
import ProfileMenuComponent from "../../profile-menu/ProfileMenuComponent";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {CommonService} from "../../../services";

export interface HeaderComponentProps {
    sideMenuView?: string,
}

const HeaderComponent = (props: HeaderComponentProps) => {

    // const {sideMenuView} = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {labListLite, modulePrimaryAttachment} = useSelector((state: IRootReducerState) => state.staticData);
    const {selectedLab} = useSelector((state: IRootReducerState) => state.selectedLab);
    const {currentNavParams} = useSelector((state: IRootReducerState) => state.header);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const {history, currentRoute} = useSelector((state: IRootReducerState) => state.stateManagement);

    const handleNavigateBack = useCallback(() => {
        const previousRoute = history && currentRoute && history[currentRoute] && history[currentRoute]?.previousRoute;
        if (previousRoute) {
            dispatch(clearPreviousNav());
            navigate(previousRoute);
        } else if (currentNavParams?.backNavigationRoute) {
            navigate(currentNavParams?.backNavigationRoute);
        } else {
            navigate(-1);
        }
    }, [currentNavParams, navigate, currentRoute, dispatch, history]);

    const handleSystemLock = useCallback(() => {
        dispatch(setSystemLocked(true, 'manual'));
    }, [dispatch]);

    const toggleFullScreen = useCallback(() => {
        const element: any = document.documentElement;
        if (isFullScreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        } else {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) { // Chrome, Safari, Opera
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE/Edge
                element.msRequestFullscreen();
            }
        }
        setIsFullScreen(!isFullScreen);
    }, [isFullScreen]);

    const handleShowAttachment = useCallback((module: string,attachment:typeof modulePrimaryAttachment['module']['attachment']) => {
        const attachmentObj = {
            name: attachment.fileName,
            type: attachment.mimeType,
            key: attachment?.id?.toString(),
            url: attachment?.url,
        }
        CommonService._communications.AttachmentPreviewSubject.next([attachmentObj])
    }, [])

    return (
        <div className='header-wrapper'>

            <div className="header-title-wrapper">
                <div className="lab-name-with-header">
                    <div className="lab-name-title">
                        {CommonService.getCurrentInstanceName(currentUser)}
                    </div>
                    {
                        currentNavParams?.backNavigationRoute ?
                            <div className={'back-navigation-wrapper'} onClick={handleNavigateBack}>
                                <div className={'back-navigation-icon'}>
                                    <ArrowBackIosNewIcon/>
                                </div>
                                <div className={'back-navigation-title'}>
                                    {currentNavParams.title}
                                </div>
                            </div> :
                            <div className={'nav-header-title-wrapper'}>
                                <div className="header-title">
                                    {currentNavParams.title}
                                </div>
                                {
                                    currentNavParams?.title === currentNavParams.meta && currentNavParams?.title?.length > 0 && modulePrimaryAttachment?.[currentNavParams?.title?.toLowerCase()]?.attachment &&
                                    <div className="nav-help-manuals"
                                         onClick={() => handleShowAttachment(currentNavParams?.title,modulePrimaryAttachment?.[currentNavParams?.title?.toLowerCase()]?.attachment)}>
                                        (View Manual)
                                    </div>
                                }
                            </div>
                    }
                </div>
                {
                    currentNavParams.title === 'Lab OS' && Object.keys(currentUser?.labDetails || {})?.length <= 0 &&
                    <div className={'lab-selection-wrapper'}>
                        <SelectDropdownComponent name={'select-dropdown'} label={'Select Lab'} options={labListLite}
                                                 size={'small'}
                                                 value={labListLite.find((lab: any) => lab.id === selectedLab)}
                                                 getOptionLabel={(option) => option.name}
                                                 onUpdate={(selectedOption: any) => {
                                                     dispatch(setSelectedLab(selectedOption?.id));
                                                 }
                                                 }
                        />
                    </div>
                }
            </div>
            <div className="header-options">
                <div className="header-option" onClick={toggleFullScreen}>
                    <ButtonComponent
                        variant={'icon'}
                        handleClick={toggleFullScreen}>
                        {isFullScreen ? <CloseFullscreenIcon/> : <OpenInFullIcon/>}
                    </ButtonComponent>
                </div>
                <div className="header-notifications header-option">
                    <NotificationModuleComponent/>
                </div>
                <div className="header-option lock">
                    <ButtonComponent
                        variant={'icon'}
                        handleClick={handleSystemLock}>
                        <LockIcon/>
                    </ButtonComponent>
                </div>
                {/*<div className="header-option help">*/}
                {/*    <ImageConfig.HelpIcon/>*/}
                {/*</div>*/}
                {/*<div className="header-option notification">*/}
                {/*    <ImageConfig.NotificationsIcon/>*/}
                {/*</div>*/}
                <ProfileMenuComponent/>
            </div>
        </div>
    )

};

export default HeaderComponent;
